import { c } from 'react-compiler-runtime';
import { clsx } from 'clsx';
import classes from './InputLabel.module.css.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function InputLabel(t0) {
  const $ = c(28);
  let children;
  let className;
  let disabled;
  let htmlFor;
  let id;
  let props;
  let required;
  let requiredIndicator;
  let requiredText;
  let t1;
  let visuallyHidden;
  if ($[0] !== t0) {
    ({
      children,
      disabled,
      htmlFor,
      id,
      required,
      requiredText,
      requiredIndicator,
      visuallyHidden,
      as: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = htmlFor;
    $[5] = id;
    $[6] = props;
    $[7] = required;
    $[8] = requiredIndicator;
    $[9] = requiredText;
    $[10] = t1;
    $[11] = visuallyHidden;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    htmlFor = $[4];
    id = $[5];
    props = $[6];
    required = $[7];
    requiredIndicator = $[8];
    requiredText = $[9];
    t1 = $[10];
    visuallyHidden = $[11];
  }
  const as = t1 === undefined ? "label" : t1;
  const Component = as;
  const t2 = disabled ? "" : undefined;
  const t3 = visuallyHidden ? "" : undefined;
  let t4;
  if ($[12] !== className) {
    t4 = clsx(className, classes.Label);
    $[12] = className;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== children || $[15] !== required || $[16] !== requiredIndicator || $[17] !== requiredText) {
    var _requiredText;
    t5 = required || requiredText ? /*#__PURE__*/jsxs("span", {
      className: classes.RequiredText,
      children: [/*#__PURE__*/jsx("span", {
        children: children
      }), /*#__PURE__*/jsx("span", {
        "aria-hidden": requiredIndicator ? undefined : true,
        children: (_requiredText = requiredText) !== null && _requiredText !== void 0 ? _requiredText : "*"
      })]
    }) : children;
    $[14] = children;
    $[15] = required;
    $[16] = requiredIndicator;
    $[17] = requiredText;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== Component || $[20] !== htmlFor || $[21] !== id || $[22] !== props || $[23] !== t2 || $[24] !== t3 || $[25] !== t4 || $[26] !== t5) {
    t6 = /*#__PURE__*/jsx(Component, {
      "data-control-disabled": t2,
      "data-visually-hidden": t3,
      htmlFor: htmlFor,
      id: id,
      className: t4,
      ...props,
      children: t5
    });
    $[19] = Component;
    $[20] = htmlFor;
    $[21] = id;
    $[22] = props;
    $[23] = t2;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  return t6;
}

export { InputLabel };
